export enum OptionMenuActions {
    CLOSE_OPTIONS_MENU = 'optionsMenu/CLOSE_OPTIONS_MENU',
    OPEN_OPTIONS_MENU = 'optionsMenu/OPEN_OPTIONS_MENU',
    ON_MENU_ITEM_CLICK = 'optionsMenu/ON_MENU_ITEM_CLICK',
    ON_TOGGLE_CONFIRM_MODAL = 'optionsMenu/ON_TOGGLE_CONFIRM_MODAL',
    ON_FILE_IS_READY_FOR_DOWNLOAD = 'optionsMenu/ON_FILE_IS_READY_FOR_DOWNLOAD',
    API_CALL_IS_FINISHED = 'optionsMenu/API_CALL_IS_FINISHED',
    CALL_DOWNLOAD_FILE_API = 'optionsMenu/CALL_DOWNLOAD_FILE_API',
    ON_FILE_IS_READY_FOR_UPLOAD = 'optionsMenu/ON_FILE_IS_READY_FOR_UPLOAD',
    ON_FILE_IS_UPLOADED = 'optionsMenu/ON_FILE_IS_UPLOADED',
    ON_CANCEL_ACTION = 'optionsMenu/ON_CANCEL_ACTION',
    ON_MARK_SCHEME_FILE_UPLOADED = 'optionsMenu/ON_MARK_SCHEME_FILE_UPLOADED',
    RESET_MARK_SCHEME_FILE_UPLOADED = 'optionsMenu/RESET_MARK_SCHEME_FILE_UPLOADED',
    DOWNLOAD_MARK_SCHEME_FILE = 'optionsMenu/DOWNLOAD_MARK_SCHEME_FILE',
    ON_UPDATED_GRADE = 'optionsMenu/ON_UPDATED_GRADE',
    ON_UPDATED_MARK = 'optionsMenu/ON_UPDATED_MARK'
}

export enum OptionsMenuActionsName {
    OPEN_GRADING_PROTOCOL = 'openGradingProtocol',
    OPEN_WORKFLOW_IN_SHARE = 'openWorkflowInShare',
    OPEN_WORKFLOW_IN_ALIGN = 'openWorkflowInAlign',
    OPEN_WORKFLOW_IN_CONFIRM = 'openWorkflowInConfirm',
    OPEN_GRADES_THRESHOLD_EDITOR = 'openGradesThresholdEditor',
    OPEN_GRADES_THRESHOLD_EDITOR_UPDATE = 'openGradesThresholdEditorUpdate',
    OPEN_QUESTION_WEIGHTS_EDITOR = 'openQuestionWeightsEditor',
    OPEN_QUESTION_ASSIGNMENTS_EDITOR = 'openQuestionAssignmentsEditor',
    OPEN_ANSWER_KEY_CORRECTION_EDITOR = 'openAnswerKeyCorrectionEditor',
    OPEN_COMMITTEE_SELECTOR = 'openCommitteeSelector',
    DOWNLOAD_AND_PRINT_ALL_SUBMISSIONS_PDF = 'downloadAndPrintAllSubmissionsPdf',
    DOWNLOAD_AND_PRINT_COMMITTEE_SUBMISSIONS_PDF = 'downloadAndPrintCommitteeSubmissionsPdf',
    DOWNLOAD_MARKS_AS_EXCEL = 'downloadMarksAsExcel',
    DOWNLOAD_GRADES_AS_EXCEL = 'downloadGradesAsExcel',
    DOWNLOAD_EXCEL_MARKING_SHEET = 'downloadExcelMarkingSheet',
    DOWNLOAD_MARKS_AND_CRITERIA = 'downloadMarksAndCriteria',
    DOWNLOAD_MARKS_AND_GRADES_AS_CSV = 'downloadMarksAndGradesAsCsv',
    DOWNLOAD_MULTIPLE_ATTEMPTS_ALL_DATA_AS_CSV = 'downloadMultipleAttemptsAllDataAsCsv',
    DOWNLOAD_MULTIPLE_ATTEMPTS_FINAL_DATA_AS_CSV = 'downloadMultipleAttemptsFinalDataAsCsv',
    DOWNLOAD_TOTAL_MARKS_AND_GRADES_AS_CSV = 'downloadTotalMarksAndGradesAsCsv',
    DOWNLOAD_ANALYSIS_AS_CSV = 'downloadAnalysisAsCsv',
    DOWNLOAD_CANDIDATE_REPORT_AS_CSV = 'downloadCandidateReportAsCsv',
    DOWNLOAD_MARK_SCHEME_SUBMENU = 'downloadMarckSchemeSubmenu',
    DOWNLOAD_MARK_SCHEME = 'downloadMarkScheme',
    DOWNLOAD_ORIGINAL_SUBMISSIONS = 'downloadOriginalSubmissions',
    UPLOAD_MARK_SCHEME = 'uploadMarkScheme',
    REPLACE_MARK_SCHEME = 'replaceMarkScheme',
    REMOVE_MARK_SCHEME = 'removeMarkScheme',
    UPLOAD_GRADES_FROM_EXCEL = 'uploadGradesFromExcel',
    VIEW_CANDIDATE_IN_MONITOR = 'viewCandidatesInMonitor',
    VIEW_QUESTION_SET_AS_STUDENT = 'viewQuestionSetAsStudent',
    VIEW_QUESTION_SET_WITH_CORRECT_ANSWERS = 'viewQuestionSetWithCorrectAnswers',
    REOPEN_GRADING = 'reopenGrading',
    TRANSFER_GRADES_FROM_COMMITTEE = 'transferGradesFromCommittee',
    OPEN_WORKFLOW_SETTINGS = 'openWorkflowInSetup',
    MANAGE_COMMITTEE_MEMBERS = 'openWorkflowInMembers',
    BYPASS_PRIVATE_GRADING = 'bypassPrivateGrading',
    CONFIRM_GRADES_ON_BEHALF_OF_GRADERS = 'confirmGradesOnBehalfOfGraders',
    CLOSE_TEST_TO_START_GRADING = 'closeTestToStartGrading',
    SHOW_CANDIDATES_REAL_NAMES = 'showCandidatesRealNames',
    OPEN_TEST_IN_DELIVER = 'openTestInDeliver',
    INVITE_GRADER = 'inviteGrader',
    MANAGE_CONTRIBUTORS = 'manageContributors',
    MANAGE_COMMITTEES = 'manageCommittees',
    EXPORT_JAGGED_ANALYSIS_RESULT_TO_MARK_MANAGER = 'exportJaggedAnalysisResultToMarkManager',
    UNAPPROVE_OWN_GRADES = 'unApproveOwnGrades',
    UNCONFIRM_FINAL_GRADES = 'unConfirmFinalGrades',
    QUESTION_SET = 'QUESTION_SET',
    DELIVER = 'DELIVER',
    EDIT_VIEW = 'EDIT_VIEW',
    MONITOR = 'MONITOR',
    VIEW_CANDIDATE_IN_MONITOR_IN_PROGRESS = 'VIEW_CANDIDATE_IN_MONITOR_IN_PROGRESS',
    VIEW_CANDIDATE_IN_MONITOR_SUBMITTED = 'VIEW_CANDIDATE_IN_MONITOR_SUBMITTED',
    VIEW_CANDIDATE_IN_MONITOR_WITHDRAWN = 'VIEW_CANDIDATE_IN_MONITOR_WITHDRAWN',
    EVENT_LOG = 'EVENT_LOG',
    PRINT_AND_DOWNLOAD_QUESTION_SET = 'PRINT_AND_DOWNLOAD_QUESTION_SET',
    VIEW_CANDIDATE_IN_MONITOR_NOT_SUBMITTED = 'VIEW_CANDIDATE_IN_MONITOR_NOT_SUBMITTED',
    VIEW_CANDIDATE_IN_MONITOR_OPEN_FOR_RESUBMISSION = 'VIEW_CANDIDATE_IN_MONITOR_OPEN_FOR_RESUBMISSION',
    MARKS_IMPORT_AS_EXCEL = 'uploadMarksFromExcel',
    SET_MODERATION_STATUS_APPROVE = 'setModerationStatusApprove',
    SET_MODERATION_STATUS_DO_NOT_APPROVE = 'setModerationStatusDoNotApprove',
}

export enum ExportFormat {
    EXCEL = 'excel',
    SCORES = 'scores',
    MULTIPLE_ATTEMPTS_CSV = 'multipleAttemptsCsv',
    TOTAL_MARKS_AND_GRADES_SUMMARY = 'totalMarksAndGradesSummary',
    MARKS_AND_CRITERIA = 'marksAndCriteria',
    JAGGED_ANALYSIS = 'jaggedAnalysis',
    ORIGINAL_SUBMISSIONS = 'originalSubmissions'
}
